import { render, staticRenderFns } from "./pageKeywordReply.vue?vue&type=template&id=81984ea8&scoped=true"
import script from "./pageKeywordReply.vue?vue&type=script&lang=js"
export * from "./pageKeywordReply.vue?vue&type=script&lang=js"
import style0 from "./pageKeywordReply.vue?vue&type=style&index=0&id=81984ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81984ea8",
  null
  
)

export default component.exports